import userContext from "./UserContext";
import { useState } from "react";


const UserState = (props) => {

    const [isauthenticated, setisauthenticated] = useState(false)

    return (
        <userContext.Provider value={{ isauthenticated, setisauthenticated}}>
            {props.children}
        </userContext.Provider>
    )
}

export default UserState